import React from 'react';
import PropTypes from 'prop-types';
import List from '@mui/material/List';
import navOptions from './navOptions';
import NavItems from './NavItems';

function NavBar(props) {
    const { onLogout, open, strideQOnlineOrdering, strideQUser } = props;
    return (
        <nav>
            <List>
                <NavItems
                    open={open}
                    onLogout={onLogout}
                    navItems={navOptions}
                    strideQOnlineOrdering={strideQOnlineOrdering}
                    strideQUser={strideQUser}
                    level={1}
                />
            </List>
        </nav>
    );
}

NavBar.propTypes = {
    onLogout: PropTypes.func.isRequired,
    open: PropTypes.bool,
    strideQOnlineOrdering: PropTypes.bool,
    strideQUser: PropTypes.bool,
};

export default NavBar;
